/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   detail similar event thunk
 */

import { getEntityProperties, getTraktorEntityId } from '@zcode-ui/web-zumper-integrations'
import { selectSimilarListables } from '@zcode/nr/es/shared/modules/similarListings/selectors'
import type { Listable, MaybeEmptyProperty } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import type { Dispatch } from 'redux'
import { selectEntity } from '../../detail/modules/entity/selectors/index'
import type { GetState } from '../../types'
import { type TrackDetailEventProps, trackDetailEvent } from './trackDetailEvent'

export interface TrackDetailSimilarEventProps {
  additionalProps?: Omit<
    TrackDetailEventProps['additionalProps'],
    'similarProperty' | 'shownSimilarPropertyIds'
  >
  name: string
  similarEntity: MaybeEmptyProperty | MaybeEmpty<Listable> | null | undefined
}

export const trackDetailSimilarEvent =
  ({ name, similarEntity, additionalProps }: TrackDetailSimilarEventProps) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const entity = selectEntity(state)
    const similarListings = selectSimilarListables(state)
    if (!similarListings?.length) {
      return
    }

    const similarListingsIds = similarListings.map((el) => getTraktorEntityId(el))
    const similarEntityProps = getEntityProperties(similarEntity ?? {}, state)
    const augmentedAdditionalProps = {
      ...additionalProps,
      similarProperty: similarEntityProps,
      shownSimilarPropertyIds: similarListingsIds,
    }
    dispatch(trackDetailEvent({ name, entity, additionalProps: augmentedAdditionalProps }))
  }
